import { render, staticRenderFns } from "./AuthSidebar.vue?vue&type=template&id=3bea427c"
import script from "./AuthSidebar.vue?vue&type=script&lang=ts"
export * from "./AuthSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports